import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { trackUpgradeClick } from '../../utils/analytics';

/**
 * Показывает на FREE плане, что данные с задержкой 6 часов.
 * Рендерится внутри TopTickers над блоком «Not investment advice».
 */
export const DataDelayNotice: React.FC = () => {
  const { isPro, isAuthenticated } = useAuth();
  const { pathname } = useLocation();
  if (isPro) return null;
  if (pathname === '/') return null;

  const upgradeTo = isAuthenticated ? '/billing' : '/login?redirect=' + encodeURIComponent('/billing?checkout=1');

  return (
    <div role="status" className="card-glass sentiment-disclaimer-card rounded-lg px-4 py-3 mb-4">
      <div className="flex items-start gap-3">
        <Clock className="w-4 h-4 text-brand-gold flex-shrink-0 mt-0.5" aria-hidden />
        <p className="text-xs text-[#bbb] leading-relaxed">
          <strong className="text-[#ccc]">Data delayed by 6 hours on FREE plan.</strong>{' '}
          <Link
            to={upgradeTo}
            className="text-[var(--color-gold-light)] font-semibold hover:underline"
            onClick={() => trackUpgradeClick(`data_delay_notice:${pathname}`)}
          >
            Upgrade for real-time
          </Link>
        </p>
      </div>
    </div>
  );
};
